export const GET_SPECIAL_BONUSES = 'GET_SPECIAL_BONUSES';
export const SET_SPECIAL_BONUSES = 'SET_SPECIAL_BONUSES';
export const ADD_SPECIAL_BONUS = 'ADD_SPECIAL_BONUS';
export const UPDATE_SPECIAL_BONUS = 'UPDATE_SPECIAL_BONUS';
export const DELETE_SPECIAL_BONUS = 'DELETE_SPECIAL_BONUS';
